import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadFileFunding = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 1.4118) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.22179 3.88889L8.41612 2.27755C8.18425 1.8138 8.0683 1.58192 7.89533 1.41251C7.74237 1.26269 7.55802 1.14876 7.35562 1.07895C7.12674 1 6.86749 1 6.349 1H3.58845C2.77949 1 2.37501 1 2.06602 1.15744C1.79423 1.29592 1.57326 1.51689 1.43478 1.78868C1.27734 2.09766 1.27734 2.50215 1.27734 3.31111V3.88889M1.27734 3.88889H12.2551C13.4686 3.88889 14.0753 3.88889 14.5388 4.12504C14.9465 4.33277 15.2779 4.66423 15.4856 5.07191C15.7218 5.53538 15.7218 6.14211 15.7218 7.35556V10.5333C15.7218 11.7468 15.7218 12.3535 15.4856 12.817C15.2779 13.2247 14.9465 13.5561 14.5388 13.7638C14.0753 14 13.4686 14 12.2551 14H4.74401C3.53056 14 2.92384 14 2.46036 13.7638C2.05268 13.5561 1.72122 13.2247 1.5135 12.817C1.27734 12.3535 1.27734 11.7468 1.27734 10.5333V3.88889Z",
			stroke: "currentColor",
			strokeWidth: 1.67,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgUploadFileFunding);
export default ForwardRef;
